import React from "react";

// Transparent red page artwork; app/browser icons separately retain the red square.
export default function ProductBrand({ square = false, width = 144, style, ...props }) {
  return (
    <img
      {...props}
      src={`${process.env.PUBLIC_URL || ""}/${square ? "vianbills-mark-light.png" : "vianbills-wordmark-light.png"}?brand=pages-v2`}
      alt="VianBills"
      width={width}
      height={square ? width : width * 217 / 720}
      style={{ display: "block", width, height: "auto", maxWidth: "100%", objectFit: "contain", flexShrink: 0, ...style }}
    />
  );
}
